import React from "react";
import { companyname, companyname1, companyname2 } from "../Constant/Index";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PhotoAnimation from "../ComponentsHome/PhotoAnimation";
const Banner = ({ getapi }) => {
  const logos = [
    { src: companyname, alt: "Company 1" },
    { src: companyname1, alt: "Company 2" },
    { src: companyname2, alt: "Company 3" },
  ];
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="banner-wrapper page-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mt-4">
              <h1 className="main-heading level-1 mt-3 mb-3 main-heading-font dark-color">
                {/* Your Pathway to Urgent Healthcare */}
                {getapi?.sectionOne?.heading}
              </h1>
              <p className="primary-regular-font extra-color-5 level-7">
                {getapi?.sectionOne?.note}
              </p>
              <div className="company-logos">
                <Slider {...settings}>
                  {getapi?.sectionOne?.sliders.map((logo, tindex) => (
                    <div key={tindex}>
                      <img
                        src={logo?.image_url}
                        className="img-fluid"
                        alt={logo.alt}
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            <div className="col-lg-6 ps-5">
              <PhotoAnimation src="your-image-url" getapi={getapi}/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
